import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { catchError, combineLatest, map, mergeMap, Observable, of } from "rxjs";
import { selectSubjectHeadsForSelectedStudentClasses, selectTeachersForSelectedStudentClasses } from "../academics/academic.selectors";
import { selectAllActivityStaff } from "../activities/activity.selectors";
import { AppState } from "../app.state";
import { selectSchoolExecutives } from "../schools/school.selectors";
import { StaffActions } from "./staff.actions";

@Injectable()
export class StaffEffects {
    constructor(
        private actions$: Actions,
        private store: Store<AppState>
    ) { }

    loadStaff$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StaffActions.loadStaff),
            mergeMap(() => {
                return combineLatest([
                    this.store.select(selectSchoolExecutives),
                    this.store.select(selectTeachersForSelectedStudentClasses),
                    this.store.select(selectSubjectHeadsForSelectedStudentClasses),
                    this.store.select(selectAllActivityStaff)
                ]).pipe(
                    map(([executives, teachers, subjectHeads, coaches]) => {
                        const staffList = { executives, teachers, subjectHeads, coaches };
                        return StaffActions.loadStaffSuccess({ staffList });
                    }),
                    catchError((error): Observable<Action> => {
                        return of(StaffActions.loadStaffFailure({ error }));
                    })
                );
            })
        )
    );
}